import "./Styles/App.scss";
import Navbar from "./components/commonComponents/navBar/navbar";
import Createuser from "./components/user/createUser/userPersonalInformation/userPersonalInformation";
import { Route, Routes } from "react-router-dom";
import EmailConfirmation from "./components/user/createUser/emailConfirmation/emailConfirmation";
import AddressConfirmation from "./components/commonComponents/home-page/HomePage";
import AddressConfirmPlusCreatNewUser from "./components/user/createUser/addressConfirmation/addressConfirmPlusCreatNewUser";
import UserLogIn from "./components/user/userLogin/userLogIn";
import Restaurants from "./components/restaurants/view-all-restaurants/restaurants";
import UserProfileAndEditUserData from "./components/user/userProfileAndEdit/userProfile";
import AddRestaurant from "./components/restaurants/add-restaurant/add-restaurant/addRestaurant";
import AddRestaurantCoverAndAddress from "./components/restaurants/add-restaurant/add-restaurant-cover-and-address/upload-crop-cover/uploadCover";
import MyRestaurant from "./components/restaurants/view-edit-my-restaurant/viewEditMyRestaurant";
import RestaurantView from "./components/restaurants/view-a-restaurant/viewRestaurant";
import MyOrdersHistory from "./components/restaurants/orders-history/ordersHistory";
import AdminDashboard from "./components/adminDashboard/adminDashboard";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <AddressConfirmation />
            </>
          }
        ></Route>

        <Route
          path="/restaurant/addRestaurant"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <AddRestaurant />
            </>
          }
        ></Route>
        <Route
          path="/restaurant/addRestaurantCover"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <AddRestaurantCoverAndAddress />
            </>
          }
        ></Route>

        <Route
          path="/restaurant/myRestaurant"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <MyRestaurant />
            </>
          }
        ></Route>
        <Route
          path="/restaurant/myOrdersHistory"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <MyOrdersHistory />
            </>
          }
        ></Route>
        <Route
          path="/restaurant/restaurantView"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <RestaurantView />
            </>
          }
        ></Route>

        <Route
          path={`/restaurants`}
          element={
            <>
              {/* <Navbar /> */}
              <Restaurants />
            </>
          }
        ></Route>

        <Route
          path="/user/addressConfirmatioCreatUser"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <AddressConfirmPlusCreatNewUser />
            </>
          }
        ></Route>
        <Route
          path="/user/emailConfirmation"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <EmailConfirmation />
            </>
          }
        ></Route>
        <Route
          path="/user/creatuser"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <Createuser />
            </>
          }
        ></Route>
        <Route
          path="/logIn"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <UserLogIn />
            </>
          }
        ></Route>
        <Route
          path="/user/updateUser"
          element={
            <>
              <Navbar showLocationSearchBar={false} />
              <UserProfileAndEditUserData />
            </>
          }
        ></Route>
        <Route
          path="/admin/adminDashboard"
          element={
            <>
              <AdminDashboard />
            </>
          }
        ></Route>
      </Routes>
    </div>
  );
}

export default App;
